//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';

export default {
  name: 'ManageMember',
  data() {
    return {
      error: null,
      success: false,
      loading: false,
      userEmail: null,
      memberId: null,
    };
  },
  methods: {
    ...mapActions(['cancelSubscription']),
    async findUserById() {
      this.loading = true;
      try {
        const { data: { member: [data] } } = await this.$container.dao.getMember(this.memberId);
        this.member = data;
      } catch (err) {
        this.error = err;
      } finally {
        this.loading = false;
      }
    },
    async closeAccount() {
      try {
        this.loading = true;
        await this.cancelSubscription(this.memberId);
        this.subscriptionCanceled = true;
        this.success = true;
      } catch (err) {
        this.loading = false;
        this.error = err;
      } finally {
        this.loading = false;
      }
    },
    async deleteAccount() {
      try {
        this.loading = true;
        await this.$container.dao.deleteAccount(this.memberId);
        this.success = true;
      } catch (err) {
        this.loading = false;
        this.error = err;
      }
    },
  },
};
